import { KYMW2200Model } from '../kymw2200.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * メールアドレス反映
  *
 * @export
 * @class UpdateMailAddressService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateMailAddressService extends PlessJsonResponderSub<any> {

  vo = {
    CodeValue : '',
    MailAddress : '',
  };

  // 処理に使用するModel
  private model: KYMW2200Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateMailAddressService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        Rec: {
          condition: {
            CodeValue: this.vo.CodeValue,
            MailAddress: this.vo.MailAddress,
          }
        }
      }
    })
  }


  /**
   * API呼び出し
   *
   * @param model
   * @memberof UpdateMailAddressService
   */
  execute(model: KYMW2200Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('updateMailAddress', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateMailAddressService
   */
  success(data: any) {
    // OCR印刷会社のメールアドレスに変更後のメールアドレスを反映する
    this.model.kymw2200Component.setMailAddressReflect();
  }
}
